import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { border } from '@guardian/src-foundations/palette';
import { from } from '@guardian/src-foundations/mq';
import { center } from '@root/src/web/lib/center';
const padding = css `
	padding: 0 10px;

	${from.mobileLandscape} {
		padding: 0 20px;
	}
`;
const adStyles = css `
	& .ad-slot.ad-slot--collapse {
		display: none;
	}
`;
const sideBorders = (colour) => css `
	${from.tablet} {
		border-left: 1px solid ${colour};
		border-right: 1px solid ${colour};
	}
`;
const topBorder = (colour) => css `
	border-top: 1px solid ${colour};
`;
const setBackgroundColour = (colour) => css `
	background-color: ${colour};
`;
export const ElementContainer = ({ sectionId, showSideBorders = true, showTopBorder = true, padded = true, borderColour = border.secondary, backgroundColour, shouldCenter = true, children, }) => (_jsx("section", Object.assign({ css: [
        adStyles,
        backgroundColour && setBackgroundColour(backgroundColour),
    ] }, { children: _jsx("div", Object.assign({ id: sectionId, css: [
            shouldCenter && center,
            showSideBorders && sideBorders(borderColour),
            showTopBorder && topBorder(borderColour),
            padded && padding,
        ] }, { children: children && children }), void 0) }), void 0));
